if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.submitButton.classList.contains('.product-form__submit')) {
        this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
      } else {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      if (window.matchMedia('(max-width: 600px)').matches && !document.querySelector('.template-product-tea')) $('.quick-add__submit .button_add_text').text('Add')
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      /* FOR PRE-ORDER ISSUE */
      /*      this.submitButton.classList.add('loading');
           this.querySelector('.loading-overlay__spinner').classList.remove('hidden'); */

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } /* else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          } */

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          this.submitButton.classList.add('finally');
          if (this.submitButton.querySelector('span')) this.submitButton.querySelector('span').textContent = '1 In Cart'
          setTimeout(() => {
            this.submitButton.classList.remove("finally");
            if (!mql) {
              if (!document.querySelector('.template-product-tea')) {

                this.submitButton.querySelector('span').textContent = 'Add To Cart'
              } else {
                this.submitButton.querySelector('span').textContent = 'Buy Now'

              }
            } else {
              this.submitButton.querySelector('span').textContent = 'Add'
            }
          }, 2000);
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          window.SLIDECART_UPDATE();
          window.SLIDECART_OPEN();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
